import { useMutation, useQueryClient } from "react-query";
import { useContext } from "react";
import { AuthContext } from "../../Context/AuthContext";

const unblockUser = async (userId, token) => {
  const response = await fetch(`${process.env.REACT_APP_SERVER_URL}/users/unblock/${userId}`, {
    method: "PATCH",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  });

  const data = await response.json();
  if (!response.ok) {
    throw new Error(data.message || "Failed to unblock user");
  }
  return data;
};

const useUnblockUser = () => {
  const queryClient = useQueryClient();
  const { token } = useContext(AuthContext);

  return useMutation(({ userId }) => unblockUser(userId, token), {
    onSuccess: (_data, { userId }) => {
      queryClient.invalidateQueries("merchants");
      queryClient.invalidateQueries("customers");
      queryClient.invalidateQueries(["user", userId]);
      queryClient.invalidateQueries(["customer", userId]);
    },
  });
};

export default useUnblockUser;
